import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "xdoc-page-content",
  style: {"flex-shrink":"0","flex-grow":"1","max-width":"100%","display":"flex","align-items":"flex-start","flex-direction":"column","font-size":"16px","line-height":"1.5","width":"100%","z-index":"1","padding-bottom":"15vh","padding-left":"0px","padding-right":"0px","min-height":"240px"}
}
const _hoisted_2 = ["data-block-id"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { style: {"color":"rgba(55, 53, 47, 0.5)","padding":"5px 2px 24px"} }, " Press Enter to continue with an empty page, or pick a template ", -1)
const _hoisted_4 = [
  _hoisted_3
]

import BlockRender from "./BlockRender.vue";
import { computed } from "vue";
import { useRecordValuesStore } from "@/stores/recordValues";
import uuid from "@/helpers/globals/uuid";


export default /*#__PURE__*/_defineComponent({
  __name: 'PageContent',
  props: {
    blockId: {
        type: String,
        required: true,
    },
    spaceId: {
        type: String,
        required: true
    }
},
  setup(__props) {

const props = __props

const recordValuesStore = useRecordValuesStore();

const pageContentInStore = computed(function() {
    return recordValuesStore.getRecordValue(
        props.blockId,
        "block",
        "f2cf1fd1-8789-4ddd-9190-49f41966c446"
    )?.content
})

function appendNewChildToPage() {
    const blockId = uuid();
    
    recordValuesStore.setNewChild(
        props.blockId,
        "content",
        blockId,
        "f2cf1fd1-8789-4ddd-9190-49f41966c446"
    )

}

// const keystrokesStore = useKeyStrokeStore();

// function handleKeyUpEvent(e: Event): void {
//     const selection = window.getSelection();
//     const range = selection?.getRangeAt(0);
//     const rect = range?.getBoundingClientRect();

//     if (e.code === "Slash") {
//         keystrokesStore.setTrackCommand(true);
//         keystrokesStore.setAnchorOffset(selection?.anchorOffset as number - 1);
//         keystrokesStore.setPositions(rect?.x || 0, rect?.y || 0);
//     }

//     keystrokesStore.setFocusOffset(selection?.focusOffset as number);

//     keystrokesStore.handleKeyStroke(e.code, e.key, {
//         text: selection?.focusNode?.textContent
//     });
// }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!pageContentInStore.value?.length)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", {
            "data-block-id": props.blockId,
            class: "xdoc-selectable xdoc-page-block"
          }, null, 8, _hoisted_2),
          _createElementVNode("div", { style: {"width":"100%","display":"flex","flex-direction":"column","margin-bottom":"14vh"} }, [
            _createElementVNode("div", {
              onClick: appendNewChildToPage,
              style: {"width":"100%"}
            }, _hoisted_4)
          ])
        ], 64))
      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(pageContentInStore.value, (blockId) => {
          return (_openBlock(), _createBlock(BlockRender, {
            key: blockId,
            "block-id": blockId,
            "space-id": props.spaceId
          }, null, 8, ["block-id", "space-id"]))
        }), 128))
  ]))
}
}

})